import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const publicApi = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
    // withCredentials: true,
});

// const queryErrorHandler = (error: unknown): void => {
//     console.log('::queryErrorHandler:: error :', (error as AxiosError)?.message);
// };

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 0,
            staleTime: 0,
            // onError: queryErrorHandler,
        },
    },
});
